import { ReactNode, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { Box, Toolbar, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// project import
import Drawer from './Drawer';
import Footer from './Footer';
import Header from './Header';

import useConfig from 'hooks/useConfig';

// types
import { openDrawer } from 'store/reducers/menu';
import { RootStateProps } from 'types/root';

// ==============================|| MAIN LAYOUT ||============================== //

interface Props {
  children: ReactNode;
}

const MainLayout = ({ children }: Props) => {
  const theme = useTheme();
  const matchDownLG = useMediaQuery(theme.breakpoints.down('md'));

  const { miniDrawer } = useConfig();
  const dispatch = useDispatch();

  const menu = useSelector((state: RootStateProps) => state.menu);
  const { drawerOpen } = menu;

  // drawer toggler
  const [open, setOpen] = useState(!miniDrawer || drawerOpen);
  const handleDrawerToggle = () => {
    setOpen(!open);
    dispatch(openDrawer({ drawerOpen: !open }));
  };

  // set media wise responsive drawer
  useEffect(() => {
    if (!miniDrawer) {
      setOpen(!matchDownLG);
      dispatch(openDrawer({ drawerOpen: !matchDownLG }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownLG]);

  return (
    <Box
      sx={{
        display: 'flex',
        /** ไม่ให้แถว flex ยืดความสูงตาม sibling (Drawer/พื้นที่ fixed) จน document สูงเกินเนื้อหา */
        alignItems: 'flex-start',
        width: '100%',
        minHeight: 0
      }}
    >
      <Header open={open} handleDrawerToggle={handleDrawerToggle} />

      <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          /** ความสูงตามเนื้อหาเท่านั้น — กันเลื่อนลงไปเจอพื้นที่ว่างโดยไม่มี view */
          alignSelf: 'flex-start',
          height: 'max-content',
          minHeight: 0,
          minWidth: 0,
          p: { xs: 2.5, sm: 2.5 },
          maxWidth: { xl: 'calc(100vw - 260px)', md: 'calc(100vw - 260px)', sm: 'calc(100vw)', xs: 'calc(100vw)' }
        }}
      >
        <Toolbar />
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            minHeight: 0
          }}
        >
          {children}
          <Footer />
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayout;
